import React,{Component, useState} from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import {color, bgcolor} from '../../../sass-files/variable';
import BlackJack from '../../../images/blackjack.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
// import BetOnPoker from '../../../images/betonpoker.jpg';
// import Wheel from '../../../images/wheel.jpg';
import Lucky7 from 'src/images/lucky7.jpg'
import DragonTiger from '../../../images/drogontiger.jpg';
import Lucky5 from '../../../images/lucky5.jpg';
// import CardCasino from '../../../images/cardcasino.jpg';
// import Teenpatti from '../../../images/teenpatti.jpg';
// import Matka from '../../../images/matka.jpg';
// import SlickImagejackpot from '../../../images/Jackpot.png';
// import SlickImageRoulette from '../../../images/Roulette.png';
import Baccarat from '../../../images/baccarat-carousal.png';
import JokerBet from '../../../images/CasinoJokerBetHin.jpg';
import WheelBet from '../../../images/wheelBetVTVHin.jpg';
import Baccarat2 from '../../../images/baccaratNewHin.jpg';
import PokerNew from '../../../images/casinoPokerHin.jpg';
import FruitRace from '../../../images/casinoFruitRace1Hin.jpg';
import RouletteNew from '../../../images/casinoRouletteHin.jpg';
import BetNumber from '../../../images/casinoBetNumberHin.jpg';
import LiveDiceNew from '../../../images/casinoliveDiceHin.jpg';
import BlackJackNew from '../../../images/blackJackCasinoGameHin.jpg';
import Cards from '../../../images/32casinoCardsHin.jpg';
// import SlickImageBlackJack from '../../../images/blackjack-carousal.png';
import Modal from 'src/components/Modal';
import CasinoGames from 'src/components/eu-content/casino-page/casino-slider-Games';
import config from 'src/config/config';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import Intl from '../../common/Intl';
import { ifProp, theme, withProp } from 'styled-tools';

import {SRTM} from 'src/util/sportradarEvent';
import { withAppContext } from "src/store/initAppContext";
import { CRMDesktopMiniBannerClick } from 'src/util/crmUtil';
// import { Lucky7 } from 'src/images/casino-images/ss_bacca_2.jpg';


// Filter Content Images
const Andarbahar = `${'static/Image/andarbahar.jpg'}`
const Andarbahar1 = `${'static/Image/andar-bahar-ezuzi_laptopnew.jpg'}`
const Andarbahar2 = `${'static/Image/andarbahar2.jpg'}`
const AmarAkbarAnthony = `${'static/Image/amar_akbar_anthony.jpg'}`
const LiveCasinoMain = `${'static/Image/'}`
// const DragonTiger = `${'static/Image/dragon_tiger.jpg'}`
const DragonTiger1 = `${'static/Image/dragon_tiger1.jpg'}`
const DragonTiger2 = `${'static/Image/dragontiger2.jpg'}`
const DragonTiger3 = `${'static/Image/dragontiger3.jpg'}`
const DragonTiger4 = `${'static/Image/dragontiger4.jpg'}`
const DragonTiger5 = `${'static/Image/dragontiger5.jpg'}`
const DreamCatcher = `${'static/Image/dream_catcher.jpg'}`
const DiceDual = `${'static/Image/dice_laptop.jpg'}`
const Dicedual = `${'static/Image/dice_dual_laptop.jpg'}`
// const CardCasino = `${'static/Image/32cardcasino.jpg'}`
const CardCasino1 = `${'static/Image/32cardcasino1.jpg'}`
const FootballStudio = `${'static/Image/footballstudio.jpg'}`
const Roullette = `${'static/Image/roullette.jpg'}`
const Roulette1 = `${'static/Image/roulette1.jpg'}`
const Roulette2 = `${'static/Image/roulette2.jpg'}`
const Roulette3 = `${'static/Image/roulette3.jpg'}`
const Roulette4 = `${'static/Image/roulette4.jpg'}`
const Roulette5 = `${'static/Image/roulette5.jpg'}`
// const BlackJack = `${'static/Image/black_jack.jpg'}`
const Blackjack1 = `${'static/Image/blackjack1.jpg'}`
const Blackjack2 = `${'static/Image/blackjack2.jpg'}`
const SicBo = `${'static/Image/sicbo.jpg'}`
const SicBo1 = `${'static/Image/sicbo1.jpg'}`
const SicBo2 = `${'static/Image/sicbo2.jpg'}`
const SideBetCity = `${'static/Image/sidebetcity.jpg'}`
// const SuperSpadeRoulette = `${'static/Image/superspaderoulette.jpg'}`
// const Baccarat = `${'static/Image/baccarat.jpg'}`
// const Baccarat1 = `${'static/Image/baccarat1.jpg'}`
// const Baccarat2 = `${'static/Image/baccarat2.jpg'}`
// const Baccarat3 = `${'static/Image/baccarat3.jpg'}`
// const Baccarat4 = `${'static/Image/baccarat4.jpg'}`
// const Baccarat5 = `${'static/Image/baccarat5.jpg'}`
// const Baccarat6 = `${'static/Image/baccarat6.jpg'}`
// const Baccarat7 = `${'static/Image/baccarat7.jpg'}`
// const Baccarat8 = `${'static/Image/baccarat8.jpg'}`
// const Baccarat9 = `${'static/Image/baccarat9.jpg'}`
const Poker1 = `${'static/Image/poker_laptop.jpg'}`
const Poker2 = `${'static/Image/bet_on_poker_laptop.jpg'}`
const Poker3 = `${'static/Image/sixpoker_laptop.jpg'}`
const Poker4 = `${'static/Image/speedy-7_laptop.jpg'}`
const Poker5 = `${'static/Image/poker5.jpg'}`
const HiLo = `${'static/Image/hi_lo.jpg'}`
const LightningDice = `${'static/Image/lightningdice.jpg'}`
// const Lucky7 = `${'static/Image/lucky7.jpg'}`
const Lucky6 = `${'static/Image/lucky6.jpg'}`
// const Lucky5 = `${'static/Image/lucky5.jpg'}`
// const SpinAWin = `${'static/Image/spin_a_win.jpg'}`
const WarofBets1 = `${'static/Image/war_of_bets_1.jpg'}`
// const Wheel = `${'static/Image/wheel.jpg'}`
// const TeenPatti = `${'static/Image/live_casino_main.png'}`
const TeenPatti1 = `${'static/Image/teen_patti.jpg'}`
// const TeenPatti2 = `${'static/Image/teenpatti1.jpg'}`
// const TeenPatti3 = `${'static/Image/teenpatti2.jpg'}`
// const TeenPatti4 = `${'static/Image/teenpatti3.jpg'}`
// const TeenPatti5 = `${'static/Image/teenpatti4.jpg'}`
const UpDown = `${'static/Image/7up&down.jpg'}`
const UpDown1 = `${'static/Image/7up&down1.jpg'}`
const LotteryCasinobg = `${'static/Image/lottery-casinobg.png'}`
const baccaratlaptop = `${'static/Image/baccarat-laptop.jpg'}`
const baccarat2laptop = `${'static/Image/baccarat2-laptop.jpg'}`
const roulettelaptop = `${'static/Image/roulettelaptopnew.jpg'}`
const cards32laptop = `${'static/Image/32cardslaptopnew.jpg'}`
const betonnumberlaptop = `${'static/Image/betonnumberlaptopnew.jpg'}`
const baccarattlaptop = `${'static/Image/baccaratlaptopnew.jpg'}`
const dragontigertablelaptop = `${'static/Image/dragontigertablelaptopnew.jpg'}`
const teenpattilaptop = `${'static/Image/teenpattilaptopnew.jpg'}`
const lucky7laptop = `${'static/Image/lucky7laptopnew.jpg'}`
const blackjacklaptop = `${'static/Image/blackjacklaptopnew.jpg'}`

// const VivoBaccaratlaptop = `${'static/Image/Vivo-Baccarat_laptop.jpg'}`
// const VivoBlackjacklaptop = `${'static/Image/Vivo-Blackjack_laptop.jpg'}`
// const ClassicRoulettelaptop = `${'static/Image/Classic-Roulette_laptop.jpg'}`
// const VIPBlackjacklaptop = `${'static/Image/VIP-Blackjack_laptop.jpg'}`
// const SpanishRoulettelaptop = `${'static/Image/Spanish-Roulette_laptop.jpg'}`
// const VIPBaccaratlaptop = `${'static/Image/VIP-Baccarat_laptop.jpg'}`
// const ClassicBaccaratlaptop = `${'static/Image/Classic-Baccarat_laptop.jpg'}`
// const UruguayEuropeanRoulettelaptop = `${'static/Image/Uruguay-European-Roulette_laptop.jpg'}`
// const MacauRoulettelaptop = `${'static/Image/Macau-Roulette_laptop.jpg'}`
// const OrientalBaccaratlaptop = `${'static/Image/Oriental-Baccarat_laptop.jpg'}`
// const MacauBaccaratlaptop = `${'static/Image/Macau-Baccarat_laptop.jpg'}`
// const AmericanPortugueseRoulettelaptop = `${'static/Image/American-Portuguese-Roulette_laptop.jpg'}`
// const PortomasoCasinolaptop = `${'static/Image/Portomaso-Casino_laptop.jpg'}`
// const AutoRoulettelaptop = `${'static/Image/Auto-Roulette_laptop.jpg'}`
// const OracleRoulettelaptop = `${'static/Image/Oracle-Roulette_laptop.jpg'}`
// const Oracle360Roulettelaptop = `${'static/Image/Oracle-360-Roulette_laptop.jpg'}`
// const CasinoHoldemlaptop = `${'static/Image/Casino-Holdem_laptop.jpg'}`
// const VivoAladdinBaccaratlaptop = `${'static/Image/Vivo-Aladdin-Baccarat_laptop.jpg'}`

const bacaratlaptop = `${'static/Image/bacarat_laptop.jpg'}`
const blackjacknetent = `${'static/Image/blackjack-netent_laptop.jpg'}`

const kenolaptop = `${'static/Image/keno_laptop.jpg'}`
const jokerbetlaptop = `${'static/Image/joker-bet_laptop.jpg'}`
const sevenbetlaptop = `${'static/Image/seven_bet_laptop.jpg'}`
const fivebettvbetlaptop = `${'static/Image/5-bet-tvbet_laptop.jpg'}`
const twenty1bettvbetlaptop = `${'static/Image/21-bet--tvbet_laptop.jpg'}`
const pokertvbetlaptop = `${'static/Image/poker-tvbet_laptop.jpg'}`
const WHEELBETtvbetlaptop = `${'static/Image/WHEELBET_tvbet_laptop.jpg'}`
const warofelemntstvbetlaptop = `${'static/Image/war-of-elemnts-tvbet_laptop.jpg'}`
const onebetlBackgammontvbetlaptopaptop = `${'static/Image/Backgammon-tvbet_laptop.jpg'}`
const LUCKY6tvbetlaptop = `${'static/Image/LUCKY6_tvbet_laptop.jpg'}`
const FRUITRACEtvbetlaptop = `${'static/Image/FRUITRACE-tvbet_laptop.jpg'}`
const onebetlaptop = `${'static/Image/one-bet_laptop.jpg'}` 

const andar = `${'/static/media/andar-bahar.png'}`

// BETSOFT 

const baccaratBSlaptop = `${'static/Image/baccaratBSlaptop.png'}`
const ZOOMROULETTElaptop = `${'static/Image/ZOOM-ROULETTE_betsoft.jpg'}`
const BlackjackBSlaptop = `${'static/Image/square_btn_european_blackjack.jpg'}`
const takeolympuslaptop = `${'static/Image/take-olympus_laptop.jpg'}`
const MonsterPoplaptop = `${'static/Image/Monster-Pop_laptop.jpg'}`
const backtovenuslaptop = `${'static/Image/back-to-venus_laptop.jpg'}`
const FRUITZENLAPTOP = `${'static/Image/FRUIT-ZEN_LAPTOP.jpg'}`
const sugarpoplaptop = `${'static/Image/sugar-pop_laptop.jpg'}`
const OASISPOKERlaptop = `${'static/Image/square_btn_oasis_poker.png'}`

// JACKPOT

const smalljackpot = `${'static/Image/JACKPOTSMALL.png'}`

// TEENPATTIPLUS

const teenpattiPlus1 = `${'static/Image/tennpatti2020.png'}` 
const andaarbahar = `${'static/Image/andarbahar11.png'}`
const teenpattiplus2 = `${'static/Image/tenpattiplusnew.png'}`

const {secondarycolor} = color
const {loginbg} = bgcolor
const {loginbghover} = bgcolor
const {signupbghover} = bgcolor
const isAuth = cookieUtil.get(ECookieName.COOKIE_TOKEN);

function BottomSection(props) {
    const casinoGameList = [
        {
            id: 1,
            type: 'EVOLUTION',
            game: "baccarat",
            // url: 'http://google.com',
            platformCode: "WACS",
            code: "EVOLUTION-baccarat-lobby",
            imgsrc: Baccarat
        },
        {
            id: 2,
            type: 'EVOLUTION',
            game: "black_jack",
            // url: 'http://google.com',
            imgsrc: BlackJack,
            platformCode: "WACS",
            code: "EVOLUTION-blackjack-lobby",
        },
        {
            id: 3,
            type: 'EVOLUTION',
            game: "dream_catcher",
            // url: 'http://google.com',
            imgsrc: DreamCatcher,
            platformCode: "WACS",
            code: window.innerWidth > 576 ? "EVOLUTION-moneywheel-MOWDream00000001" : "EVOLUTION-moneywheel-nvrpo3bv6teqkuco",
        },
        {
            id: 4,
            type: 'EVOLUTION',
            game: "footballstudio",
            // url: 'http://google.com',
            imgsrc: FootballStudio,
            platformCode: "WACS",
            code: "EVOLUTION-rng~topcard-rng~topcard00001",
        },
        {
            id: 5,
            type: 'EVOLUTION',
            game: "lightningdice",
            // url: 'http://google.com',
            imgsrc: LightningDice,
            platformCode: "WACS",
            code: "EVOLUTION-roulette-LightningTable01",
        },
        {
            id: 6,
            type: 'betgames',
            game: "poker",
            // url: 'http://google.com',
            imgsrc: Poker1,
            platformCode: "WACS",
            code: "BGAMES-12",
        },
        {
            id: 7,
            type: 'betgames',
            game: "poker",
            // url: 'http://google.com',
            imgsrc: Poker1,
            platformCode: "WACS",
            code: "BGAMES-12",
        },
        {
            id: 8,
            type: 'EVOLUTION',
            game: "roulette",
            // url: 'http://google.com',
            imgsrc: SideBetCity,
            platformCode: "WACS",
            code: "EVOLUTION-roulette-lobby",
        },
        {
            id: 9,
            type: 'super-spade',
            game: "andar bahar-laptop",
            // url: 'http://google.com',
            imgsrc: Andarbahar,
            platformCode: "WACS",
            code: "Ab1lkajgh7trgh20",
        },
        // {
        //     id: 10,
        //     type: 'super-spade',
        //     game: "dragon tiger-laptop",
        //     // url: 'http://google.com',
        //     imgsrc: DragonTiger,
        //     platformCode: "WACS",
        //     code: "Dt19er0d1t2iew37",
        // },
        // {
        //     id: 11,
        //     type: 'super-spade',
        //     game: "roulette-laptop",
        //     // url: 'http://google.com',
        //     imgsrc: Roulette2,
        //     platformCode: "WACS",
        //     code: "Rou1hq4jo2etrjg3",
        // },
        {
            id: 12,
            type: 'super-spade',
            game: "teen_patti-laptop",
            // url: 'http://google.com',
            imgsrc: TeenPatti1,
            platformCode: "WACS",
            code: "Tnptikajgh8t2020",
        },
        // {
        //     id: 13,
        //     type: 'super-spade',
        //     game: "baccarat-laptop",
        //     // url: 'http://google.com',
        //     imgsrc: baccaratlaptop,
        //     platformCode: "WACS",
        //     code: "Bacc5a7r5to2etrl",
        // },
        // {
        //     id: 14,
        //     type: 'super-spade',
        //     game: "baccarat2-laptop",
        //     // url: 'http://google.com',
        //     imgsrc: baccarat2laptop,
        //     platformCode: "WACS",
        //     code: "Baccara2786tblew",
        // },
        {
            id: 15,
            type: 'betgames',
            game: "baccarat_laptop",
            // url: 'http://google.com',
            imgsrc: Baccarat2,
            platformCode: "WACS",
            code: "BGAMES-6",
        },
        {
            id: 16,
            type: 'betgames',
            game: "bet on poker_laptop",
            // url: 'http://google.com',
            imgsrc: Poker2,
            platformCode: "WACS",
            code: "BGAMES-5",
        },
        {
            id: 17,
            type: 'betgames',
            game: "dice dual_laptop",
            // url: 'http://google.com',
            imgsrc: DiceDual,
            platformCode: "WACS",
            code: "BGAMES-10",
        },
        {
            id: 18,
            type: 'betgames',
            game: "dice _laptop",
            // url: 'http://google.com',
            imgsrc: Dicedual,
            platformCode: "WACS",
            code: "BGAMES-4",
        },
        {
            id: 19,
            type: 'betgames',
            game: "Lucky 5_laptop",
            // url: 'http://google.com',
            imgsrc: Lucky5,
            platformCode: "WACS",
            code: "BGAMES-3",
        },
        {
            id: 20,
            type: 'betgames',
            game: "Lucky 6_laptop",
            // url: 'http://google.com',
            imgsrc: Lucky6,
            platformCode: "WACS",
            code: "BGAMES-9",
        },
        {
            id: 21,
            type: 'betgames',
            game: "Lucky 7_laptop",
            // url: 'http://google.com',
            imgsrc: Lucky7,
            platformCode: "WACS",
            code: "BGAMES-1",
        },
        {
            id: 22,
            type: 'betgames',
            game: "sixpoker_laptop",
            // url: 'http://google.com',
            imgsrc: Poker3,
            platformCode: "WACS",
            code: "BGAMES-12",
        },
        {
            id: 23,
            type: 'betgames',
            game: "speedy-7_laptop",
            // url: 'http://google.com',
            imgsrc: Poker4,
            platformCode: "WACS",
            code: "BGAMES-11",
        },
        {
            id: 24,
            type: 'betgames',
            game: "war_of_bets_1_laptop",
            // url: 'http://google.com',
            imgsrc: WarofBets1,
            platformCode: "WACS",
            code: "BGAMES-8",
        },
        {
            id: 25,
            type: 'betgames',
            game: "wheel of fortune_laptop",
            // url: 'http://google.com',
            imgsrc: UpDown1,
            platformCode: "WACS",
            code: "BGAMES-7",
        },
        {
            id: 26,
            type: 'EZUGI',
            game: "andar-bahar-ezuzi",
            // url: 'http://google.com',
            imgsrc: Andarbahar1,
            platformCode: "WACS",
            code: "EZUGI-AndarBahar_228000",
        },
        {
            id: 27,
            type: 'EZUGI',
            game: "blackjack_laptop",
            // url: 'http://google.com',
            imgsrc: blackjacklaptop,
            platformCode: "WACS",
            code: "EZUGI-lobby",
        },
        {
            id: 28,
            type: 'EZUGI',
            game: "roulette_laptop",
            // url: 'http://google.com',
            imgsrc: roulettelaptop,
            platformCode: "WACS",
            code: "EZUGI-lobby",
        },
        {
            id: 29,
            type: 'EZUGI',
            game: "32-cards_laptop",
            // url: 'http://google.com',
            imgsrc: cards32laptop,
            platformCode: "WACS",
            code: "EZUGI-32cards_228002",
        },
        {
            id: 30,
            type: 'EZUGI',
            game: "bet-on-number_laptop",
            // url: 'http://google.com',
            imgsrc: betonnumberlaptop,
            platformCode: "WACS",
            code: "EZUGI-Lottery_602000",
        },
        {
            id: 31,
            type: 'EZUGI',
            game: "baccarat_laptop",
            // url: 'http://google.com',
            imgsrc: baccarattlaptop,
            platformCode: "WACS",
            code: "EZUGI-lobby",
        },
        {
            id: 32,
            type: 'EZUGI',
            game: "dragon-tiger-table_laptop",
            // url: 'http://google.com',
            imgsrc: dragontigertablelaptop,
            platformCode: "WACS",
            code: "EZUGI-BaccaratDragonTiger_150",
        },
        {
            id: 33,
            type: 'EZUGI',
            game: "teenpatti_laptop",
            // url: 'http://google.com',
            imgsrc: teenpattilaptop,
            platformCode: "WACS",
            code: "EZUGI-ThreeCardPoker_227100",
        },
        {
            id: 34,
            type: 'EZUGI',
            game: "lucky-7_laptop",
            // url: 'http://google.com',
            imgsrc: lucky7laptop,
            platformCode: "WACS",
            code: "EZUGI-lucky7_228001",
        },
        {
            id: 35,
            type: 'NETENT',
            game: "poker_laptop",
            // url: 'http://google.com',
            imgsrc: Poker5,
            platformCode: "WACS",
            code: "NETENT-casinoholdem_not_mobile_sw",
        },
        {
            id: 36,
            type: 'NETENT',
            game: "bacarat_laptop",
            // url: 'http://google.com',
            imgsrc: bacaratlaptop,
            platformCode: "WACS",
            code: "NETENT-casinoholdem_not_mobile_sw",
        },
        {
            id: 37,
            type: 'NETENT',
            game: "blackjack-netent_laptop",
            // url: 'http://google.com',
            imgsrc: blackjacknetent,
            platformCode: "WACS",
            code: "EVOLUTION-blackjack3ne-blackjack3ne0000",
        },
        {
            id: 38,
            type: 'NETENT',
            game: "blackjack-netent_laptop",
            // url: 'http://google.com',
            imgsrc: blackjacknetent,
            platformCode: "WACS",
            code: "EVOLUTION-blackjack3ne-blackjack3ne0000",
        },
        {
            id: 39,
            type: 'TV BET',
            game: "Keno",
            // url: 'http://google.com',
            imgsrc: kenolaptop,
            platformCode: "WACS",
            code: "TVBET-9",
        },
        {
            id: 40,
            type: 'TV BET',
            game: "Jokerbet",
            // url: 'http://google.com',
            imgsrc: jokerbetlaptop,
            platformCode: "WACS",
            code: "TVBET-8",
        },
        {
            id: 41,
            type: 'TV BET',
            game: "7Bet",
            // url: 'http://google.com',
            imgsrc: sevenbetlaptop,
            platformCode: "WACS",
            code: "TVBET-7",
        },
        {
            id: 42,
            type: 'TV BET',
            game: "5Bet",
            // url: 'http://google.com',
            imgsrc: fivebettvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-6",
        },
        {
            id: 43,
            type: 'TV BET',
            game: "21Bet",
            // url: 'http://google.com',
            imgsrc: twenty1bettvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-4",
        },
        {
            id: 44,
            type: 'TV BET',
            game: "poker",
            // url: 'http://google.com',
            imgsrc: pokertvbetlaptop,
            platformCode: "WACS",
            code: "TTVBET-3",
        },
        {
            id: 45,
            type: 'TV BET',
            game: "Wheelbet",
            // url: 'http://google.com',
            imgsrc: WHEELBETtvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-2",
        },
        {
            id: 46,
            type: 'TV BET',
            game: "WAR OF ELEMENTS",
            // url: 'http://google.com',
            imgsrc: warofelemntstvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-5",
        },
        {
            id: 47,
            type: 'TV BET',
            game: "Backgammon",
            // url: 'http://google.com',
            imgsrc: onebetlBackgammontvbetlaptopaptop,
            platformCode: "WACS",
            code: "TVBET-1",
        },
        {
            id: 48,
            type: 'TV BET',
            game: "Lucky6",
            // url: 'http://google.com',
            imgsrc: LUCKY6tvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-12",
        },
        {
            id: 49,
            type: 'TV BET',
            game: "FRUITRACE",
            // url: 'http://google.com',
            imgsrc: FRUITRACEtvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-14",
        },
        {
            id: 50,
            type: 'TV BET',
            game: "FRUITRACE",
            // url: 'http://google.com',
            imgsrc: FRUITRACEtvbetlaptop,
            platformCode: "WACS",
            code: "TVBET-14",
        },
        {
            id: 51,
            type: 'BETSOFT',
            game: "BACCARAT",
            // url: 'http://google.com',
            imgsrc: baccaratBSlaptop, 
            platformCode: "WACS",
            code: "BETSOFT-13",
        },
        {
            id: 52,
            type: 'BETSOFT',
            game: "ZOOM-ROULETTE",
            // url: 'http://google.com',
            imgsrc: ZOOMROULETTElaptop,
            platformCode: "WACS",
            code: "BETSOFT-278",
        },
        {
            id: 53,
            type: 'BETSOFT',
            game: "EUROPEAN BLACKJACK",
            // url: 'http://google.com',
            imgsrc: BlackjackBSlaptop,
            platformCode: "WACS",
            code: "BETSOFT-191",
        }, 
        {
            id: 54,
            type: 'BETSOFT',
            game: "OASIS POKER",
            // url: 'http://google.com',
            imgsrc: OASISPOKERlaptop,
            platformCode: "WACS",
            code: "BETSOFT-203",
        },
        // {
        //     id: 59,
        //     type: 'JACKPOT',
        //     game: "JACKPOT",
        //     // url: 'http://google.com',
        //     imgsrc: smalljackpot,
        //     platformCode: "SLottery",
        //     code: "SLottery",
        // },
        {
            id: 55,
            type: 'TEENPATTIPLUS',
            game: "TEENPATTIPLUS2020",
            // url: 'http://google.com',
            imgsrc: teenpattiPlus1,
            platformCode: "AgTeenpatti",
            code: "",
        },
        
        {
            id: 56,
            type: 'TEENPATTIPLUS',
            game: "TEENPATTIPLUS",
            // url: 'http://google.com',
            imgsrc: teenpattiplus2,
            platformCode: "AgTeenpatti",
            code: "",
        },
        {
            id: 57,
            type: 'TEENPATTIPLUS',
            game: "ANDARBAHAR",
            // url: 'http://google.com',
            imgsrc: andaarbahar,
            platformCode: "AgTeenpatti",
            code: "",
        },
        {
            id: 58,
            type: 'TV BET',
            game: "Jokerbet",
            catagoryName: "Card Game",
            // url: 'http://google.com',
            imgsrc: jokerbetlaptop,
            platformCode: "WACS",
            code: "TVBET-8",
        },
        {
            id: 59,
            type: 'EZUGI',
            game: "32-cards_laptop",
            catagoryName: "32 Card Casino",
            // url: 'http://google.com',
            imgsrc: cards32laptop,
            platformCode: "WACS",
            code: "EZUGI-32cards_228002",
        },
        // {
        //     id: 60,
        //     type: 'super-spade',
        //     game: "baccarat2-laptop",
        //     catagoryName: "Baccarat",
        //     // url: 'http://google.com',
        //     imgsrc: baccarat2laptop,
        //     platformCode: "WACS",
        //     code:"Baccara2786tblew" ,
        // },
        {
            id: 61,
            type: 'betgames',
            game: "bet on poker_laptop",
            catagoryName: "Poker",
            // url: 'http://google.com',
            imgsrc: Poker2,
            platformCode: "WACS",
            code: "BGAMES-5" ,
        },
        {
            id: 62,
            type: 'EZUGI',
            game: "bet-on-number_laptop",
            catagoryName: "Jackpot",
            // url: 'http://google.com',
            imgsrc: betonnumberlaptop,
            platformCode: "WACS",
            code: "EZUGI-Lottery_602000",
        },
        {
            id: 63,
            type: '7MOJOS',
            game: "Andar Bahar",
            catagoryName: "Andar Bahar",
            // url: 'http://google.com',
            imgsrc:  andar,
            platformCode: "WACS",
            code: "7MOJOS-ab-1",
        }
 
    ];
    const [modal, setModal ]= useState(false);
    const handleClose = () => setModal(false);

    const { app: { brandId }} = props

    const toggleModal = (gameName) => {
        setSelectedGame([gameName])
        setModal(!modal)

        //for sport Radar
        if(gameName && typeof gameName === 'object'){
            SRTM.retargetCasinoEvent(brandId, {
                id: gameName.id || '',
                name: gameName.game,
                category: gameName.type,
                image: gameName.imgsrc
            })
            
            //CRM CRMDesktopMiniBannerClick
            CRMDesktopMiniBannerClick(brandId,gameName.imgsrc)
        }
       
    }

    const [selectedGame, setSelectedGame]= useState([]);

        return (
            <BottomSectionWrapper>
                <FirstColoumn>
                    <Link to="/" className="colfirst">
                        {/* <img src={BlackJack} alt="Black Jack"></img> */}
                        {/* <h4>Blackjack</h4> */}
                        <Intl langKey="HOMEPAGE@GAME1">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() => toggleModal(casinoGameList[39])}><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[39])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="/" className="colsec">
                        {/* <img src={BetOnPoker} alt="Bet On Poker"></img> */}
                        {/* <h4>Bet on Poker</h4> */}
                        <Intl langKey="HOMEPAGE@GAME2">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[60]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[60])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="/" className="colthired">
                        {/* <img src={Wheel} alt="Wheel"></img> */}
                        {/* <h4>Wheel</h4> */}
                        <Intl langKey="HOMEPAGE@GAME3">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[49]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> :  <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[49])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                               
                            </div>
                        </div>
                    </Link>
                </FirstColoumn>
                <SecondColoumn>
                    <Link to="/" className="colfourth">
                        {/* <img src={Lucky7} alt="Lucky 7"></img> */}
                        {/* <h4>Lucky 7</h4> */}
                        <Intl langKey="HOMEPAGE@GAME4">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[57])}><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[57])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="/" className="colfifth">
                        {/* <img src={DragonTiger} alt="Dragon Tiger"></img> */}
                        {/* <h4>Dragon Tiger</h4> */}
                        <Intl langKey="HOMEPAGE@GAME5">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[7]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[7])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                </SecondColoumn>
                <ThiredColoumn>
                    <Link to="" className="colsixth">
                        {/* <img src={Lucky5} alt="Lucky 5"></img> */}
                        {/* <h4>Lucky 5</h4> */}
                        <Intl langKey="HOMEPAGE@GAME6">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[44]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[44])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="" className="colseventh">
                        {/* <img src={CardCasino} alt="Card Casino"></img> */}
                        {/* <h4>Side Bet City</h4> */}
                        <Intl langKey="HOMEPAGE@GAME7">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} />
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[61]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[61])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="" className="coleighth">
                        {/* <img src={Teenpatti} alt="Teenpatti"></img> */}
                        {/* <h4>Teenpatti</h4> */}
                        <Intl langKey="HOMEPAGE@GAME8">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[17]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[17])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                </ThiredColoumn>
                <FourthColoumn>
                    <Link to="" className="colninth">
                        {/* <img src={Matka} alt="Matka"></img> */}
                        {/* <h4>Lightning Dice</h4> */}
                        <Intl langKey="HOMEPAGE@GAME9">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() =>  toggleModal(casinoGameList[37]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[37])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                    <Link to="" className="coltenth">
                        {/* <img src={Baccarat} alt="Baccarat"></img> */}
                        {/* <h4>Baccarat</h4> */}
                        <Intl langKey="HOMEPAGE@GAME10">
                            {(message) => {
                                return (
                                    <LazyLoadImage src={`${config.imageS3Host}${message}`} effect="none" height="100%" width="100%"  placeholder={<PlaceholderImage/>}/>
                                );
                            }}
                        </Intl>
                        <div className="overlay">
                            <div className="buttons">
                                {
                                    cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                                    <button onClick={() => toggleModal(casinoGameList[58]) }><Intl langKey="TITLE@PLAY" /></button>
                                </PlayButton> : <DemoButton>
                                    <button onClick={() => toggleModal(casinoGameList[58])}><Intl langKey="TITLE@DEMO" /></button>
                                </DemoButton>
                                }
                                
                                
                            </div>
                        </div>
                    </Link>
                </FourthColoumn>
                <Modal show={modal} handleClose={handleClose}>
                <CasinoGames modalState={modal} data={selectedGame} open={'true'}/>   
                </Modal>
            </BottomSectionWrapper>
        )
    };

export default withAppContext(BottomSection)

const BottomSectionWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.9;
        background: ${theme('palette.overlayBGColor')};
        overflow: hidden;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transition: .5s ease;
        transition: .5s ease;
      }
      
      .buttons {
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
`;

const PlayButton = styled.div`
    transform: skew(340deg);
    /* border: 1px solid #CB9640; */
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    /* background:linear-gradient(180deg, #000000 0%, #2F3236 100%);  */
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;
    

    :hover {
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }

    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        /* color: ${secondarycolor}; */
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

const DemoButton = styled.div`
    transform: skew(340deg);
    /* border: 1px solid #CB9640; */
    border: ${theme('palette.DemoButtonBorder')};
    margin-left: 10px;
    /* background: linear gradient(#37B8BB(60% opacity),#1C5C5E(40% opacity)); */
    background: ${theme('palette.DemoButtonBg')};
    box-shadow: 3px 5px 4px rgba(0, 0, 0, 0.25);
    transition: color 0.1s linear 0s;

    :hover {
        background: ${theme('palette.primary-background-color-linear-new')};
        transition: color 0.1s linear 0s;
    }

    button {
        width: 80px;
        text-align: center;
        display: block;
        text-decoration: none;
        padding: 10px 0px;
        font-size: 14px;
        transform: skew(-340deg);
        /* color: ${secondarycolor}; */
        color: ${theme('palette.DemoButtonColor')};
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
`;

const FirstColoumn = styled.div`
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;

    a {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        border: 1px solid #333;
        margin: 5px 5px 0px 0px;
        position: relative;
        cursor: default;
        background-position: top;

        img {
            max-width: 100%;
            width: 100%;
            height: 100%;
        }

        @media only screen and (max-width: 1440px){
            background-position: center;
        }	
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .colfirst {
        height: 270px;
        /* background-image: url(${config.imageS3Host}${JokerBet}); */
        align-items: flex-end;
        background-size: cover;

        h4 {
            bottom: 30px;
        }
    }
    .colsec {
        height: 270px;
        /* background-image: url(${config.imageS3Host}${PokerNew}); */
        background-size: cover;

    }
    .colthired {
        height: 460px;
        /* background-image: url(${config.imageS3Host}${FruitRace}); */
        background-size: cover;

    }

    h4 {
        position: absolute;
        left: 1.5em;
        margin: 0;
        font-size: 30px;
        color: ${secondarycolor};
        
        text-transform: uppercase;
    }
`;

const SecondColoumn = styled.div`
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0px 5px;

    a {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        border: 1px solid #333;
        margin: 5px 5px 0px 0px;
        position: relative;
        cursor: default;
        background-position: top;


        @media only screen and (max-width: 1440px){
            background-position: center;
        }

        img {
            max-width: 100%;
            width: 100%;
            height: 100%;
        }
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .colfourth {
        height: 270px;
        /* background-image: url(${config.imageS3Host}${Baccarat2}); */
        background-size: cover;
        align-items: flex-end;
        h4 {
            bottom: 30px;
        }
    }
    .colfifth {
        height: 735px;
        background-size: cover;
        /* background-image: url(${config.imageS3Host}${RouletteNew}); */
        h4 {
            bottom: 150px;
        }
    }

    h4 {
        position: absolute;
        left: 1.5em;
        margin: 0;
        font-size: 30px;
        color: ${secondarycolor};
        
        text-transform: uppercase;
    }
`;

const ThiredColoumn = styled.div`
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;

    a {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        border: 1px solid #333;
        margin: 5px 5px 0px 0px;
        position: relative;
        cursor: default;
        background-position: top;


        @media only screen and (max-width: 1440px){
            background-position: center;
        }

        img {
            max-width: 100%;
            width: 100%;
            height: 100%;
        }
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .colsixth {
        height: 270px;
        /* background-image: url(${config.imageS3Host}${WheelBet}); */
        align-items: flex-end;
        background-size: cover;


        h4 {
            bottom: 30px;
        }
    }
    .colseventh {
        height: 270px;
        /* background-image: url(${config.imageS3Host}${BetNumber}); */
        background-size: cover;

    }
    .coleighth {
        height: 460px;
        /* background-image: url(${config.imageS3Host}${LiveDiceNew}); */
        background-size: cover;

    }

    h4 {
        position: absolute;
        left: 1.5em;
        margin: 0;
        font-size: 30px;
        color: ${secondarycolor};
        
        text-transform: uppercase;
    }
`;

const FourthColoumn = styled.div`
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;

    a {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        border: 1px solid #333;
        margin: 5px 5px 0px 0px;
        cursor: default;
        background-position: top;


        @media only screen and (max-width: 1440px){
            background-position: center;
        }

        img {
            max-width: 100%;
            width: 100%;
            height: 100%;
        }
    }

    a:hover .overlay {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .colninth {
        height: 595px;
        /* background-image: url(${config.imageS3Host}${BlackJackNew}); */
        margin-right: 0;
        align-items: flex-end;
        background-size: cover;


        h4 {
            bottom: 70px;
        }
    }
    .coltenth {
        height: 410px;
        /* background-image: url(${config.imageS3Host}${Cards}); */
        margin-right: 0;
        background-size: cover;

    }

    h4 {
        position: absolute;
        left: 1.5em;
        margin: 0;
        font-size: 30px;
        color: ${secondarycolor};
        
        text-transform: uppercase;
    }
`;